export type BlogFeedItem = {
  title: string;
  url: string;
  pubDate: Date;
};

export const BLOG_FEED_URL = "/blog/rss.xml";

const parseRssItems = (xml: string): BlogFeedItem[] => {
  const doc = new DOMParser().parseFromString(xml, "application/xml");
  if (doc.querySelector("parsererror")) {
    throw new Error("Invalid RSS feed");
  }

  const items = Array.from(doc.querySelectorAll("item"));
  const posts: BlogFeedItem[] = [];

  for (const item of items) {
    const title = item.querySelector("title")?.textContent?.trim();
    const url = item.querySelector("link")?.textContent?.trim();
    const pubDateRaw = item.querySelector("pubDate")?.textContent?.trim();
    if (!title || !url || !pubDateRaw) continue;

    const pubDate = new Date(pubDateRaw);
    if (Number.isNaN(pubDate.getTime())) continue;

    posts.push({ title, url, pubDate });
  }

  return posts.sort((a, b) => b.pubDate.getTime() - a.pubDate.getTime());
};

export const fetchBlogFeed = async (): Promise<BlogFeedItem[]> => {
  const response = await fetch(BLOG_FEED_URL);
  if (!response.ok) {
    throw new Error(`Failed to fetch blog feed (${response.status})`);
  }

  const xml = await response.text();
  const posts = parseRssItems(xml);
  if (posts.length === 0) {
    throw new Error("Blog feed contained no posts");
  }

  return posts;
};
